// Endereço de um item da Central a partir do que se sabe dele fora da
// Central (nota privada, cartão na conversa) e os filtros da fila que viajam
// junto quando a pessoa abre um item e volta. Funções puras, testadas em
// specs/itemLinks.spec.js.

// Área de cada tipo de item (Ai::ActionItem::KINDS). O slug é o da URL.
export const AREA_SLUG_BY_KIND = Object.freeze({
  social: 'comentarios',
  opportunity: 'retomadas',
  property: 'imoveis',
  kanban: 'kanban',
  conversion: 'conversoes',
});

export const areaSlugForKind = kind => AREA_SLUG_BY_KIND[kind] || '';

// Filtros das filas: origem (Retomadas), funil (Kanban), período, rede e
// plataforma (Comentários e Conversões), status, pessoa e faixa de nota
// (Ligações), motivo (Reports da IA) e o mundo de onde a pessoa veio (barra
// "Voltar para"). `page` fica de fora: a fila recomeça do topo.
export const QUEUE_FILTER_KEYS = Object.freeze([
  'source',
  'funnel_id',
  'from',
  'to',
  'provider',
  'status',
  'agent_id',
  'score',
  'category',
  'from_world',
]);

const firstValue = value => (Array.isArray(value) ? value[0] : value);

export const queueFilterQuery = (query = {}) =>
  Object.fromEntries(
    QUEUE_FILTER_KEYS.map(key => [key, firstValue(query?.[key])]).filter(
      ([, value]) => value !== undefined && value !== null && value !== ''
    )
  );
